import script from "./ContatoreTable1.vue?vue&type=script&setup=true&lang=js"
export * from "./ContatoreTable1.vue?vue&type=script&setup=true&lang=js"

import "./ContatoreTable1.vue?vue&type=style&index=0&id=25038ecc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25038ecc"]])

export default __exports__